import React from 'react'
import { withRouter } from 'react-router'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Card, Flex, ActionSheet } from 'antd-mobile'
import { Modal } from 'components'
import paymentIcon from './images/payment.png'
import withdrawIcon from './images/withdrawal.png'
import { intl } from 'utils'

class BankCard extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  handleBankLogoLoadError = (e) => {
    e.target.src = require('./images/default-bank.png')
  }

  showMenu = () => {
    const { history, cardId, deleteCard, payAttribute } = this.props
    const options = [intl.formatMessage(messages.action1)]
    if (payAttribute === 'withdraw') {
      options.push(intl.formatMessage(messages.actionDeleteAccount))
    } else {
      options.push(intl.formatMessage(messages.actionDeleteBankCard))
    }
    options.push(intl.formatMessage(messages.action3))
    ActionSheet.showActionSheetWithOptions(
      {
        options: options,
        cancelButtonIndex: 2,
        maskClosable: true,
      },
      (buttonIndex) => {
        switch (buttonIndex) {
          case 0:
            history.push(`/transaction/history?cardId=${cardId}`)
            break
          case 1:
            Modal.alert(
              '',
              <div className='text-left'>
                {payAttribute === 'withdraw'
                  ? intl.formatMessage(messages.deleteAccountConfirmInfo)
                  : intl.formatMessage(messages.deleteCardConfirmInfo)}
              </div>,
              [
                {
                  text: <span>{intl.formatMessage(messages.delete)}</span>,
                  onPress: () => deleteCard(cardId, payAttribute),
                },
                {
                  text: (
                    <span className='green'>
                      {intl.formatMessage(messages.notNow)}
                    </span>
                  ),
                },
              ]
            )
            break
          default:
            break
        }
      }
    )
  }

  handleCardFlag = () => {
    const { expireFlag, payAttribute } = this.props
    const EXPIRE_FLAG = [
      '',
      intl.formatMessage(messages.validDateDue),
      intl.formatMessage(messages.validDateOverdue),
      '',
    ]
    const CARD_FLAG = {
      payment: paymentIcon,
      withdraw: withdrawIcon,
    }
    if (expireFlag === '1' || expireFlag === '2') {
      return (
        <div className={classes[`validDate${expireFlag}`]}>
          {EXPIRE_FLAG[expireFlag]}
        </div>
      )
    }
    return <img height='13' src={CARD_FLAG[payAttribute]} />
  }

  render() {
    const {
      bankName,
      cardOrgShow,
      iconUrl,
      cardNo,
      iban,
      payAttribute,
      accountHolderName,
    } = this.props
    if (payAttribute === 'withdraw') {
      return (
        <Flex
          className={`${classes.componentsBankCard} ${classes.newAccountStyle}`}
          onClick={this.showMenu}
        >
          <img
            width='40'
            src={iconUrl}
            onError={this.handleBankLogoLoadError}
          />
          <Flex.Item>
            <p className='font-xs gray'>{accountHolderName}</p>
            <Flex className={classes.cardNo} justify='between'>
              <span>****</span>
              <span>****</span>
              <span>******</span>
              <span>****</span>
              <span style={{ marginTop: -4 }}>{iban.substr(-4)}</span>
            </Flex>
            <p className='font-xs'>{bankName}</p>
          </Flex.Item>
        </Flex>
      )
    }
    return (
      <Card
        className={`${classes.componentsBankCard} ${payAttribute}`}
        onClick={this.showMenu}
      >
        <Card.Header
          title={payAttribute === 'withdraw' ? bankName : cardOrgShow}
          extra={
            <img
              width='30'
              src={iconUrl}
              onError={this.handleBankLogoLoadError}
            />
          }
        />
        <Card.Body>
          {payAttribute === 'withdraw' ? (
            <React.Fragment>
              <div className={classes.smallFont}>
                <FormattedMessage {...messages.ibanNumber} />
              </div>
              <Flex className={classes.cardNo} justify='between'>
                <span>****</span>
                <span>****</span>
                <span>******</span>
                <span>****</span>
                <span style={{ marginTop: -4 }}>{iban.substr(-4)}</span>
              </Flex>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className={classes.smallFont}>
                <FormattedMessage {...messages.cardNumber} />
              </div>
              <Flex className={classes.cardNo} justify='between'>
                <span>****</span>
                <span>****</span>
                <span>****</span>
                <span style={{ marginTop: -4 }}>{cardNo.substr(-4)}</span>
                <span style={{ width: '20%' }} />
              </Flex>
            </React.Fragment>
          )}
        </Card.Body>
        <Card.Footer
          content={accountHolderName}
          extra={this.handleCardFlag()}
        />
      </Card>
    )
  }
}

export default withRouter(BankCard)
